import { ReturnStruct } from '../../structs/return.struct';
import { NFeEntradaFormacaoPrecosItemResultadoStruct } from '../../structs/orquestrador-compras/nfe-entrada-formacao-precos-item-resultado.struct';

/** Custo e venda calculados pelo motor da Suprimentos, sem gravar nada. */
export class NFeEntradaFormacaoPrecosPreviaResponse extends ReturnStruct {
  public valorImpostosRecuperaveis = 0;
  public itens: NFeEntradaFormacaoPrecosItemResultadoStruct[] = [];
}
